import { Download } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography, Chip } from '@mui/material';
import { H5, Tiny } from 'components/Typography';
import FormatDate from 'utils/formatDate';

const hotelColumnShape = [
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        Cell: ({ value }) => {
            const date = FormatDate(value, 'dd MMM yyyy');
            const time = FormatDate(value, 'HH:mm');
            return (
                <Box sx={{ whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">{date}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {time}
                    </Typography>
                </Box>
            );
        },
    },
    {
        Header: 'Number',
        accessor: 'number',
        Cell: ({ row }) => {
            return (
                <>
                    <Typography variant="body2">{row.original?.number}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {row.original?.roomType}
                    </Typography>
                </>
            );
        },
    },
    {
        Header: 'Name & Email',
        accessor: 'user',
        Cell: ({ row }) => {
            const { user } = row.original;
            return (
                <>
                    <H5 mb={0}>{user?.fullName}</H5>
                    <Tiny my={1}>{user?.email}</Tiny>
                </>
            );
        },
    },
    {
        Header: 'Check-in',
        accessor: 'reservation.checkIn',
        Cell: ({ row }) => {
            const checkIn = row.original?.checkIn;
            const text = checkIn ? FormatDate(checkIn, 'dd MMM yyyy') : '-';
            return <Typography variant="body2">{text}</Typography>;
        },
    },
    {
        Header: 'Check-out',
        accessor: 'reservation.checkOut',
        Cell: ({ row }) => {
            const checkOut = row.original?.checkOut;
            const text = checkOut ? FormatDate(checkOut, 'dd MMM yyyy') : '-';
            return <Typography variant="body2">{text}</Typography>;
        },
    },
    {
        Header: 'Nights',
        accessor: 'nights',
        Cell: ({ value }) => {
            return <Typography variant="body2">{value} night(s)</Typography>;
        },
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => (
            <Chip
                label={value?.label || ''}
                sx={{
                    backgroundColor: value?.bgColor || 'grey.200',
                    color: value?.color || 'text.primary',
                    fontWeight: 600,
                }}
                size="small"
            />
        ),
    },
    {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row, handleDownload, isLoading }) => {
            let showButtonDownload;
            localStorage.getItem('role') === 'operator' ||
            localStorage.getItem('role') === 'admin'
                ? (showButtonDownload = 'block')
                : (showButtonDownload = 'none');
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <IconButton
                        onClick={() => handleDownload(row.original)}
                        sx={{ display: showButtonDownload }}
                        disabled={isLoading?.value}
                    >
                        <Tooltip title="Download">
                            <Download
                                sx={{
                                    color: 'text.primary',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                </Box>
            );
        },
    },
];

export default hotelColumnShape;
